// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d120412","455":"29906995","488":"38e66b37","977":"c8ac2aae"}[chunkId] + ".chunk.js";
};